import React from "react";
import {
  Instagram,
  Youtube,
  Mail,
  Linkedin,
  Facebook,
  ArrowUpRight,
} from "lucide-react";
import { socialMediaText } from "i18n/socialmedia";
import { useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

const SocialMedia = () => {
  const lang = useSelector((state) => state.language.lang);

  const t = socialMediaText[lang];

  const navigate = useNavigate();
  const location = useLocation();

  return (
    <section className="py-20 md:py-28 px-6">
      <div className="max-w-7xl mx-auto">
        {/* Two-Color Heading */}
        <h2 className="text-center text-3xl md:text-4xl tracking-widest font-semibold mb-20 font-[Crimson] uppercase ">
          <span className="text-black">{t.title1}</span>
          <span className="text-reddark"> {t.title2} </span>
        </h2>

        {/* Cards */}
        <div className="mx-auto grid grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
          {" "}
          {t.cards.map((card, index) => {
            const Icon = card.icon;
            return (
              <a
                key={index}
                href={card.path}
                target="_blank"
                rel="noopener noreferrer"
                className={`
  group relative overflow-hidden
  rounded-2xl md:rounded-[2rem]
  border   ${card.border}

  p-4 md:p-8
  min-h-[190px] md:min-h-[320px]
  shadow-sm
  transition-all duration-500
  hover:-translate-y-2
  hover:shadow-[0_25px_60px_rgba(0,0,0,0.12)]
`}
              >
                {/* TOP ACCENT */}
                <div
                  className={`
    absolute top-0 left-0
    h-1 w-0
    transition-all duration-700
    group-hover:w-full 
  `}
                />

                {/* HOVER BACKGROUND */}
                <div
                  className={`
      absolute inset-0 opacity-0
      transition-opacity duration-500
      group-hover:opacity-100
      bg-gradient-to-br ${card.gradient}
    `}
                />

                {/* CONTENT */}
                <div
                  className="
      relative z-10
      flex flex-col
      items-center
      justify-center
      text-center
      h-full
    "
                >
                  {/* ICON */}
                  <div
                    className={`
        w-14 h-14
        md:w-24 md:h-24
        rounded-full
        flex items-center justify-center
        bg-gradient-to-br ${card.gradient}
        shadow-lg md:shadow-xl
        transition-all duration-500
        group-hover:scale-105
      `}
                  >
                    <Icon className="w-6 h-6 md:w-9 md:h-9 text-white" />
                  </div>

                  {/* SUBTITLE */}
                  <p
                    className="
        mt-3 md:mt-8
        uppercase
        tracking-[0.15em]
        text-[9px] md:text-xs
        text-gray-400
        transition-colors duration-300
        group-hover:text-white/70
      "
                  >
                    {card.subtitle}
                  </p>

                  {/* TITLE */}
                  <h3
                    className="
        mt-2 md:mt-4
        text-sm md:text-lg lg:text-xl
        font-semibold
        leading-tight
        text-gray-700
        font-[Crimson]
        transition-colors duration-300
        group-hover:text-white
      "
                  >
                    {card.title}
                  </h3>
                  <p
                    className="
        mt-3 md:mt-3 capitalize
        tracking-[0.005em]
        text-[9px] md:text-xs
        text-gray-400
        transition-colors duration-300
        group-hover:text-white/70
      "
                  >
                    {card.description}
                  </p>
                </div>
              </a>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default SocialMedia;

// import React from "react";
// import { ArrowUpRight } from "lucide-react";

// import { useSelector } from "react-redux";
// import { useNavigate, useLocation } from "react-router-dom";
// import { socialMediaText } from "i18n/socialmedia";

// const SocialMedia = () => {
//   const lang = useSelector((state) => state.language.lang);

//   const t = socialMediaText[lang];

//   const navigate = useNavigate();
//   const location = useLocation();

//   return (
//     <section className="relative overflow-hidden bg-[#f6f1ea] py-24 md:py-32">
//       {/* BACKGROUND */}
//       <div className="absolute inset-0 overflow-hidden">
//         <div className="absolute top-0 right-0 w-[500px] h-[500px] bg-reddark/5 rounded-full blur-3xl" />

//         <div className="absolute bottom-0 left-0 w-[400px] h-[400px] bg-black/5 rounded-full blur-3xl" />
//       </div>

//       <div className="relative max-w-7xl mx-auto px-4 md:px-6">
//         {/* HEADER */}
//         <div className="text-center max-w-4xl mx-auto mb-20">
//           <p className="uppercase tracking-[0.35em] text-sm text-reddark mb-5">
//             {t.small}
//           </p>

//           <h2
//             className="
//               text-5xl md:text-6xl lg:text-7xl
//               leading-[0.95]
//               font-[Crimson]
//               text-[#2c0f12]
//               tracking-[-0.04em]
//             "
//           >
//             {t.title1}

//             <span className="block text-reddark italic">{t.title2}</span>
//           </h2>

//           <p className="mt-8 text-lg leading-relaxed text-black/60">
//             {t.description}
//           </p>
//         </div>

//         {/* CARDS */}
//         <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
//           {t.cards.map((card, index) => {
//             const Icon = card.icon;

//             return (
//               <a
//                 key={index}
//                 href={card.path}
//                 target="_blank"
//                 rel="noopener noreferrer"
//                 className="
//                   group relative overflow-hidden
//                   rounded-[2rem]
//                   bg-white/80 backdrop-blur-xl
//                   border border-white/60
//                   p-10
//                   text-center
//                   flex flex-col items-center
//                   shadow-sm
//                   transition-all duration-500
//                   hover:-translate-y-2
//                   hover:shadow-[0_25px_60px_rgba(0,0,0,0.12)]
//                 "
//               >
//                 {/* HOVER GRADIENT */}
//                 <div
//                   className={`
//                     absolute inset-0 opacity-0
//                     transition-opacity duration-500
//                     group-hover:opacity-100
//                     bg-gradient-to-br ${card.gradient}
//                   `}
//                 />

//                 {/* CONTENT */}
//                 <div className="relative z-10 flex flex-col items-center h-full">
//                   {/* ICON */}
//                   <div
//                     className={`
//                       w-24 h-24 rounded-full
//                       flex items-center justify-center
//                       bg-gradient-to-br ${card.gradient}
//                       shadow-xl
//                       transition-all duration-500
//                       group-hover:scale-105
//                     `}
//                   >
//                     <Icon className="w-9 h-9 text-white" />
//                   </div>

//                   {/* SUBTITLE */}
//                   <p
//                     className="
//                       mt-8
//                       uppercase tracking-[0.25em]
//                       text-xs
//                       text-black/40
//                       transition-colors duration-300
//                       group-hover:text-white/60
//                     "
//                   >
//                     {card.subtitle}
//                   </p>

//                   {/* TITLE */}
//                   <h3
//                     className="
//                       mt-4
//                       text-xl lg:text-2xl
//                       font-semibold
//                       leading-snug
//                       font-[Crimson]
//                       text-[#2c0f12]
//                       transition-colors duration-300
//                       group-hover:text-white
//                     "
//                   >
//                     {card.title}
//                   </h3>

//                   {/* DESCRIPTION */}
//                   <p
//                     className="
//                       mt-5
//                       text-sm md:text-base
//                       leading-relaxed
//                       text-black/60
//                       transition-colors duration-300
//                       group-hover:text-white/80
//                     "
//                   >
//                     {card.description}
//                   </p>

//                   {/* FOOTER */}
//                   <div className="mt-10 flex items-center gap-3">
//                     <span
//                       className="
//                         text-sm font-medium
//                         text-reddark
//                         transition-colors duration-300
//                         group-hover:text-white
//                       "
//                     >
//                       {t.visit}
//                     </span>

//                     <div
//                       className="
//                         w-10 h-10 rounded-full
//                         bg-black/5
//                         flex items-center justify-center
//                         transition-all duration-300
//                         group-hover:bg-white/20
//                         group-hover:rotate-45
//                       "
//                     >
//                       <ArrowUpRight className="w-5 h-5 text-black/50 group-hover:text-white" />
//                     </div>
//                   </div>
//                 </div>
//               </a>
//             );
//           })}
//         </div>
//       </div>
//     </section>
//   );
// };

// export default SocialMedia;
